import { useCallback, useMemo } from 'react';
import type { Struct } from 'superstruct';

import { lensWithOnChange, useUrlQueryLens } from './lens';
import { onResultSetChange } from './use-table-params';
import { urlQueryStructLens } from './use-url-query-struct';

/**
 * A modified version of `useUrlQueryStruct` used for setting the
 * value of a filter in a data table.
 */
export function useUrlQueryTableFilter<
	T extends Struct<Record<string, unknown>, unknown>,
>(path: string, struct: T) {
	const [value, setValue] = useUrlQueryLens(
		useMemo(
			() =>
				lensWithOnChange(urlQueryStructLens(path, struct), onResultSetChange),
			[path, struct]
		)
	);

	return {
		value,
		setValue,
		clearValue: useCallback(() => setValue(undefined), [setValue]),
	};
}
